module.exports = {
          srcSet: __webpack_public_path__ + "images/2024-adb52863a3b3e009791aa001f47ea8b4-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2024-38f342775fd0387d8bb61ef01eae920b-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2024-adb52863a3b3e009791aa001f47ea8b4-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2024-38f342775fd0387d8bb61ef01eae920b-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2024-adb52863a3b3e009791aa001f47ea8b4-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2024-adb52863a3b3e009791aa001f47ea8b4-320.jpg"},
          
          width: 320,
          height: 251
        }